import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, switchMap, throwError } from 'rxjs';
import { IUser } from 'src/app/interfaces';
import { AppStore } from 'src/app/stores/app-store';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from '../error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private _userUrl: string = `${environment.apiUrl}/api/user`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  infoUser(): Observable<IUser> {
    return this.http.get<IUser>(`${this._userUrl}/info`, {}).pipe(
      map((data: IUser) => {
        return data;
      }),
      catchError((err) => {
        this.errorHandler.handleError(err);
        return throwError(() => err);
      }),
    );
  }

  updateUser(userData: Partial<IUser>): Observable<IUser> {
    return this.http
      .post<IUser>(`${this._userUrl}/info/update`, {
        ...userData,
      })
      .pipe(
        switchMap((data) => {
          return this.infoUser()
        }),
        catchError((err) => {
          this.errorHandler.handleError(err);
          return throwError(() => err);
        }),
      );
  }

  changeUserPassInit(email: string) {
    return this.http.post(`${this._userUrl}/new-pass/init`, { email }).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        this.errorHandler.handleError(err);
        return throwError(() => err);
      }),
    );
  }

  changeUserPassVerify(email: string, code: string, newPass: string) {
    return this.http.post(`${this._userUrl}/new-pass`, { email, code, pass: newPass }).pipe(
      map((data) => {
        return data;
      }),
      catchError((err) => {
        this.errorHandler.handleError(err);
        return throwError(() => err);
      }),
    );
  }

  changeUserPassword(oldPass: string, newPass: string): Observable<any> {
    return this.http.post(`${this._userUrl}/password/update`, { currentPassword: oldPass, newPassword: newPass }).pipe(
      catchError((err) => {
        this.errorHandler.handleError(err);
        return throwError(() => err);
      }),
    );
  }
}
